module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', [_vm._v("\n      СТОИМОСТЬ РАЗМЕЩЕНИЯ НА ПОРТАЛЕ ДЛЯ АДВОКАТОВ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col li-cancel"
  }, [_c('p', {
    staticClass: "cansel-text"
  }, [_c('ui_text', [_vm._v("При оформлении подписки на тариф Вы получаете возможность неограниченного пользования услугами портала. Всем новым адвокатам мы предоставляем доступ к порталу на 60 дней без абонентской платы:")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Вашу анкету видят клиенты")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Персональный рейтинг, который влияет на место в поиске")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("\"Безопасная сделка\" - гарант того, что Вы получите деньги за работу")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Конфиденциальность информации: мы не вмешиваемся в ваши договоренности. О них знаете только Вы и клиент. Все данные защищены надежным шифрованием")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Круглосуточная поддержка. Мы всегда на связи по любым вопросам")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row row-tarif"
  }, [_c('div', {
    staticClass: "col tarif-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row tarif-price"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth1) + " Р\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row tarif-button"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.pay(_vm.settings.priceMonth1)
      }
    }
  }, [_vm._v("Подключить")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col tarif-wrapper"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row tarif-price"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth3) + " Р\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row tarif-button"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.pay(_vm.settings.priceMonth3)
      }
    }
  }, [_vm._v("Подключить")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col tarif-wrapper"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row tarif-price"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceMonth6) + " Р\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row tarif-button"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.pay(_vm.settings.priceMonth6)
      }
    }
  }, [_vm._v("Подключить")])]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', {
    attrs: {
      "id": "pm-widget-1635797042453"
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col tarif-wrapper"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row tarif-price"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  " + _vm._s(_vm.settings.priceYear) + " Р\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row tarif-button"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.pay(_vm.settings.priceYear)
      }
    }
  }, [_vm._v("Подключить")])])])])])])]), _vm._v(" "), _c('ui_title_line', [_vm._v("\n      ОТВЕТЫ НА РАСПРОСТРАНЕННЫЕ ВОПРОСЫ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-adv"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col acord-wrapper"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordionExample"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingOne"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Можно ли бесплатно попробовать Ваш сервис?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Да, всем новым адвокатам мы предоставляем доступ к порталу на 60 дней без абонентской платы с полным функционалом")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingTwo"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Как разместиться на портале?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Вам нужно пройти простую регистрацию, которая займет не более 5 минут. Пожалуйста, подготовьте фотографии паспорта и удостоверения адвоката. После регистрации Ваша анкета попадет на модерацию. После успешного прохождения модерации Ваша анкета появится на портале и Вы получите соответствующее уведомление")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingThree"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Я не прошел модерацию. В чем дело?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseThree",
      "aria-labelledby": "headingThree",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("\n                    Если Ваша анкета по каким-то причинам не прошла модерацию, Вы получите письмо от нас с комментариями. Вот несколько причин, по которым доступ к сервису может быть запрещен:\n                    "), _c('li', [_vm._v("Неверно указанные данные при регистрации")]), _vm._v(" "), _c('li', [_vm._v("Нечеткие фотографии паспорта или удостоверения адвоката")]), _vm._v(" "), _c('li', [_vm._v("Ваш статус адвоката прекращен или приостановлен")]), _vm._v(" "), _c('li', [_vm._v("Вы занесены в черный список портала")]), _vm._v("\n                      Пожалуйста, предоставьте запрошенные нами данные. После, Ваша анкета снова попадет на модерацию\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingFour"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseFour",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v(" Как долго будет проходить модерация?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseFour",
      "aria-labelledby": "headingFour",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Мы стараемся как можно скорее проверить всех новых пользователей. Обычно это происходит в течение 1 дня. Вы можете уточнить статус Вашей анкеты, написав нам в техподдержку")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingFive"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseFive",
      "aria-expanded": "true",
      "aria-controls": "collapseFive"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Что произойдет когда бесплатный период/подписка истечет?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseFive",
      "aria-labelledby": "headingFive",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Ваша анкета не будет отображаться на сайте. Доступ к переписке и к заявкам тоже будет ограничен. Вы сможете завершить текущие(оплаченные) сделки, однако новые создать не сможете. После оплаты любого тарифа доступ будет восстановлен")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingSix"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseSix",
      "aria-expanded": "true",
      "aria-controls": "collapseSix"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Как мне привлечь больше клиентов на вашем портале?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSix",
      "aria-labelledby": "headingSix",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("\n                  Пожалуйста, укажите в анкете достоверные данные о себе: специализации, стаж работы и тд. Загрузите фотографию, добавьте описание. В личном кабинете\n                  Вы сможете редактировать информацию о себе: добавлять специализации, менять описание и тд.\n                  В нашем сервисе действует гибкая система рейтингов: проводите сделки на нашем портале и Ваш рейтинг будет расти.\n                  Адвокаты с наибольшим рейтингом показываются на главной странице, а также на первых позициях поиска для клиентов\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingSeven"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseSeven",
      "aria-expanded": "true",
      "aria-controls": "collapseSeven"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Нет смысла регистрироваться. Адвокаты, которые зарегистрировались ранее, будут выше в поиске и соответственно получать больше заявок")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseSeven",
      "aria-labelledby": "headingSeven",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Не переживайте, мы разработали справедливую систему рейтингов, учитывающую множество факторов, в том числе время пребывания на портале. Все новые пользователи получают возможность находиться на верхних позициях в поиске. Подробнее на странице:"), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/work",
      "target": "_blank"
    }
  }, [_vm._v(" Как это работает. ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingEight"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseEight",
      "aria-expanded": "true",
      "aria-controls": "collapseEight"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Я нашел клиентов, как мне дальше с ними работать?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseEight",
      "aria-labelledby": "headingEight",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("В личном кабинете Вам надо создать сделку с этим клиентом и прописать условия сотрудничества в ней: стоимость, предмет договора, сроки выполнения")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingNine"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseNine",
      "aria-expanded": "true",
      "aria-controls": "collapseNine"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Когда я получу оплату за свои услуги?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseNine",
      "aria-labelledby": "headingNine",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("После оплаты клиентом сделки средства резервируются на специальном счете. Как только работа будет выполнена и подтверждена клиентом, Вы получите оплату на реквизиты, указанные в личном кабинете")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingTen"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseTen",
      "aria-expanded": "true",
      "aria-controls": "collapseTen"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("Я выполнил договоренности с клиентом, но он не согласен. Что делать?")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTen",
      "aria-labelledby": "headingTen",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Не переживайте, все спорные сделки попадают к нам на модерацию. Мы во всем разберемся и примем решение по Вашей сделке")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "id": "headingEleven"
    }
  }, [_c('h2', {
    staticClass: "mb-0"
  }, [_c('button', {
    staticClass: "btn btn-link btn-block text-left",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseEleven",
      "aria-expanded": "true",
      "aria-controls": "collapseEleven"
    }
  }, [_c('div', {
    staticClass: "row text-title fix-header"
  }, [_c('span', {
    staticClass: "text-accord-overwflow"
  }, [_c('ui_text', [_vm._v("\n                        У клиента большое и долгое дело. Я хочу получать оплату поэтапно.\n                        Как я могу это сделать?\n                        ")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/Accord-controll.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseEleven",
      "aria-labelledby": "headingEleven",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ui_text', [_vm._v("Вы можете создавать неограниченное количество сделок с клиентом. Слона лучше есть по кусочкам. Создавайте сделки на небольшие суммы с четко прописанными договоренностями. Так Вы сможете получать оплату за каждую выполненную услугу, а клиент будет понимать весь процесс взаимодействия")])], 1)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-img-cancel"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cube.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tarif-title"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  1 месяц\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tarif-title"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  3 месяц\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tarif-title"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  6 месяц\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tarif-title"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n                  12 месяц\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2262f66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Rate/rate.vue
// module id = 380
// module chunks = 2